import { ReactNode } from 'react';
import { isPartner } from '../../../helpers/appType';
import { ConversationMessageWithStatus } from '../../../types/conversation.types';
import { ActionProposalCard } from './ActionProposalCard';
import { TicketCard } from './TicketCard';

type Props = {
  message: ConversationMessageWithStatus;
  /** Admin only: opens the ticket in the support tickets list. */
  onOpenTicket?: (ticketId: number) => void;
  /** Opens the order a ticket ended up attached to. */
  onOpenOrder?: (orderId: number) => void;
  /** Time and ticks, when the cards are the whole message. */
  meta?: ReactNode;
};

/**
 * Whatever the AI triage bot attached to a message.
 *
 * Which of the two a message carries is the backend's business, and it can be
 * both, so this only decides the order they stack in and which of them ends up
 * carrying the timestamp.
 *
 * Only the merchant may act on a card. On admin the same cards are drawn so
 * support can see what the bot offered and what the merchant did about it - the
 * routes are the merchant's own and would 404 for anyone else anyway. Read from
 * the bundle rather than passed down: it is the same answer for every card on
 * the screen, and threading a flag through the list to say which app it is
 * would be four files stating the obvious.
 */
export const MessageCards = ({
  message,
  onOpenTicket,
  onOpenOrder,
  meta,
}: Props) => {
  const proposal = message.actionProposal ?? null;
  const ticket = message.ticket ?? null;

  return (
    <>
      {proposal && (
        <ActionProposalCard
          proposal={proposal}
          interactive={isPartner}
          meta={ticket ? undefined : meta}
        />
      )}

      {ticket && (
        <TicketCard
          ticket={ticket}
          interactive={isPartner}
          onOpenTicket={onOpenTicket}
          onOpenOrder={onOpenOrder}
          meta={meta}
        />
      )}
    </>
  );
};
